export { AccordionPanelComponent } from './accordion-group.component';
export { AccordionComponent } from './accordion.component';
export { AccordionModule } from './accordion.module';
export { AccordionConfig } from './accordion.config';
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/ngx-bootstrap/accordion/index.js
// module id = 325
// module chunks = 3